/**
 * SportDataGatewayConfig defines configuration for sports data client.
 * @class SportDataGatewayConfig
 */
export class SportDataGatewayConfig {
    /**
     * Creates an instance of SportDataGatewayConfig
     * @param {string} serviceUrl Sports data service URL
     * @example
     * let config = new SportDataGatewayConfig("https://sportsapi0.staging.sbtech.com");
     */
    /* istanbul ignore next */
    constructor(serviceUrl) {
        this.serviceUrl = serviceUrl;
        this.apiEndpoint = "";
    }
}
//# sourceMappingURL=SportDataGatewayConfig.js.map